"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideFilterHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const icons_1 = require("../AdvancedFilter/icons");
const Button_1 = require("../Button");
const LinkButton_1 = require("../controls/LinkButton");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const DEFAULT_TEXTS = {
    clearAll: 'Clear All',
    search: 'Search',
    cancel: 'Cancel'
};
const StyledText = (0, styled_components_1.default)(Text_1.Text) `
    padding-right: ${helpers_1.SPACING_S};
`;
const StyledButton = (0, styled_components_1.default)(Button_1.Button) `
    min-width: 80px;
`;
const Wrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: ${helpers_1.SPACING_S} ${helpers_1.SPACING_M};

    ${({ hasFilters, theme }) => (0, styled_components_1.css) `
        background-color: ${hasFilters ? theme.colorHighlightNotification : '#fff'};
    `}
`;
const SideFilterHeader = ({ valueText, hasFilters = false, pending = false, disabledSearch = false, texts: externalTexts, onClearAllClick, onSearchClick, onSearchCancel }) => {
    const texts = Object.assign(Object.assign({}, DEFAULT_TEXTS), externalTexts);
    const handleClickRightButton = () => {
        pending ? onSearchCancel === null || onSearchCancel === void 0 ? void 0 : onSearchCancel() : onSearchClick === null || onSearchClick === void 0 ? void 0 : onSearchClick();
    };
    return (react_1.default.createElement(Wrapper, { spaceFill: View_1.SPACE_FILL.all, distribution: StackView_1.STACK_DISTRIBUTION.firstFill, gap: StackView_1.STACK_GAP.s, hasFilters: hasFilters },
        react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, spaceFill: View_1.SPACE_FILL.all, gap: StackView_1.STACK_GAP.s, indentRight: View_1.INDENT.s },
            react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.FilterIcon, null) }),
            react_1.default.createElement(StyledText, { truncate: true }, valueText),
            hasFilters && (react_1.default.createElement(LinkButton_1.LinkButton, { disabled: pending, compact: true, onClick: onClearAllClick }, texts.clearAll))),
        react_1.default.createElement(StyledButton, { ui: pending ? Button_1.BUTTON_VIEW.secondary : Button_1.BUTTON_VIEW.primary, onClick: handleClickRightButton, disabled: disabledSearch }, pending ? texts.cancel : texts.search)));
};
exports.SideFilterHeader = SideFilterHeader;
//# sourceMappingURL=SideFilterHeader.js.map